import React, { useEffect, useState } from 'react';
import { TrendingUp } from 'lucide-react';
import { adminService } from '../../../services/adminService';

const DEV_BADGE = {
  above_range: { cls: 'bg-amber-100 text-amber-800', label: 'Above range' },
  below_range: { cls: 'bg-blue-100 text-blue-800', label: 'Below range' },
  in_range: { cls: 'bg-green-50 text-green-700', label: 'In range' },
};

/**
 * Admin order-review insights: per-line ordered qty vs. historical avg/range,
 * sell-through %, and out-of-range deviation flags. Renders only when at least
 * one line has history.
 */
export const OrderInsightsSection = ({ orderId, active }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let ok = true;
    if (!active || !orderId) return undefined;
    adminService.getOrderInsights(orderId)
      .then((d) => { if (ok) setData(d); })
      .catch(() => { if (ok) setData(null); });
    return () => { ok = false; };
  }, [orderId, active]);

  const rows = (data?.lines || []).filter((l) => l.suggested_qty != null);
  if (rows.length === 0) return null;

  return (
    <div data-testid="order-insights-section">
      <p className="text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
        <TrendingUp className="h-4 w-4 text-amber-600" /> Insights
        <span className="text-xs font-normal text-gray-400">(ordered vs. sell-through history)</span>
      </p>
      <div className="border rounded-lg overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
            <tr>
              <th className="text-left px-3 py-2">Product</th>
              <th className="px-2 py-2">Ordered</th>
              <th className="px-2 py-2">Avg sold</th>
              <th className="px-2 py-2">Range</th>
              <th className="px-2 py-2">Sell-through</th>
              <th className="px-2 py-2">Flag</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {rows.map((l) => {
              const b = DEV_BADGE[l.deviation];
              return (
                <tr key={l.product_id} data-testid={`insight-row-${l.product_id}`}>
                  <td className="px-3 py-2 font-medium text-gray-900">{l.product_name}</td>
                  <td className="px-2 py-2 text-center">{l.ordered_qty}</td>
                  <td className="px-2 py-2 text-center">{l.avg_sold}</td>
                  <td className="px-2 py-2 text-center">{l.min_sold}–{l.max_sold}</td>
                  <td className="px-2 py-2 text-center">
                    {l.sell_through_rate != null ? `${Math.round(l.sell_through_rate * 100)}%` : '—'}
                  </td>
                  <td className="px-2 py-2 text-center">
                    {b && (
                      <span
                        data-testid={`deviation-${l.product_id}`}
                        className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${b.cls}`}
                      >
                        {b.label}
                      </span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrderInsightsSection;
